import { Link } from "react-router-dom";
import { FileText } from "lucide-react";

const UPDATED = "June 2026";

function Section({ title, children }) {
  return (
    <section className="mt-8">
      <h2 className="font-heading text-lg font-bold text-[#101828]">{title}</h2>
      <div className="mt-2 space-y-2 text-sm text-[#475467] leading-relaxed">{children}</div>
    </section>
  );
}

export default function Terms() {
  return (
    <div className="max-w-3xl mx-auto px-5 sm:px-8 py-12" data-testid="terms-page">
      <div className="flex items-center gap-2 text-[#0D5C75]">
        <FileText size={22} />
        <span className="font-heading font-bold uppercase tracking-wide text-xs">Legal</span>
      </div>
      <h1 className="font-heading text-3xl sm:text-4xl font-extrabold text-[#101828] mt-2">Terms of Service</h1>
      <p className="text-sm text-muted-foreground mt-2">Last updated: {UPDATED}</p>

      <Section title="1. Platform Role">
        <p>SarvaSeva is an intermediary technology platform that connects patients with independent healthcare providers. We do not practice medicine, provide medical advice, or guarantee medical outcomes. All treatment decisions are made solely between you and your chosen provider.</p>
      </Section>

      <Section title="2. No Medical Advice">
        <p>Content on this platform, including AI-generated guidance, cost estimates, and provider information, is for informational purposes only and does not constitute medical advice, diagnosis, or treatment. Always consult a qualified healthcare professional.</p>
      </Section>

      <Section title="3. Pricing & Estimates">
        <p>Prices and savings shown are estimates based on published rates and may vary by case complexity and provider evaluation. Final pricing is confirmed by your chosen provider. Estimates are current as of the date shown and are not a binding quote.</p>
      </Section>

      <Section title="4. Featured & Sponsored Listings (FTC Disclosure)">
        <p>Some providers pay for premium placement, "Featured" badges, or subscription tiers that may improve their ranking in search and matchmaking results. Featured or Sponsored listings are paid promotional placements and are labeled as such. Paid placement does not constitute an endorsement of clinical quality by SarvaSeva.</p>
      </Section>

      <Section title="5. Payments & Escrow">
        <p>Patient payments are held in escrow and released to providers against treatment milestones. Payments are processed by a third-party, PCI-DSS-compliant processor. Affiliate commissions may be earned on flights and travel insurance, and are disclosed at the point of sale.</p>
      </Section>

      <Section title="6. Third-Party Services">
        <p>Flights, accommodation, travel insurance, and consultations are provided by independent third parties under their own terms. SarvaSeva is not the insurer, airline, or medical provider and is not liable for third-party services.</p>
      </Section>

      <Section title="7. Your Responsibilities">
        <p>You agree to provide accurate information, to use the platform lawfully, and to acknowledge that medical procedures carry inherent risks. You are responsible for obtaining any required visas and travel documents.</p>
      </Section>

      <Section title="8. Data & Privacy">
        <p>Your use of the platform is also governed by our <Link to="/privacy" className="text-[#0D5C75] underline font-medium">Privacy Policy</Link>, which explains how we collect, encrypt, and process your personal and health data.</p>
      </Section>

      <Section title="9. Limitation of Liability">
        <p>To the maximum extent permitted by law, SarvaSeva is not liable for medical outcomes, provider availability, or losses arising from third-party services. The platform is provided "as is" without warranties of any kind.</p>
      </Section>

      <Section title="10. Contact">
        <p>Questions about these terms? Contact legal@sarvaseva.com.</p>
      </Section>

      <p className="mt-10 rounded-xl bg-[#FFFBEB] border border-[#D97706]/30 p-4 text-xs text-[#92400E]" data-testid="terms-legal-review-note">
        These terms are a template and have not been reviewed by legal counsel. They will be replaced with lawyer-reviewed copy before public launch.
      </p>
    </div>
  );
}
